<template>
  <div id="app"
    class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="en" page="about-us" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <article id="post-3" class="post-3 page type-page status-publish">
              <div class="inside-article">
                <header class="entry-header section-content" aria-label="Content">
                  <h1 class="entry-title" itemprop="headline">
                    Disclaimer
                  </h1>
                </header>

                <div class="section-content" itemprop="text">

                  <p>
                    The information provided on <a href="https://gbmodshub.com/" class="jump-url">gbmodshub.com </a> is for general informational and educational purposes only. We share content related to modified versions of WhatsApp, such as GB WhatsApp, to help users explore additional features and customization options not available in the official app. <br>
                    <ol>
                      <li> Not Affiliated with WhatsApp Inc. <br>
                        gbmodshub.com is an independent website and is not associated, affiliated, endorsed, or sponsored by WhatsApp Inc. or its parent company, Meta Platforms. All product names, logos, and trademarks used on this website are the property of their respective owners.
                      </li>
                      <li>
                         Use at Your Own Risk <br>
                         The modded applications available on this site are created by third-party developers. By downloading and using these apps, you acknowledge and agree that you are doing so at your own discretion and risk. We do not guarantee the security, performance, or legality of any third-party software.
                      </li>
                      <li>
                         No Responsibility for Damages <br>
                         We are not liable for any loss, damage, or data breach resulting from the use of apps downloaded from this site. Users should be aware that using modified versions of WhatsApp may violate WhatsApp's Terms of Service and could lead to account bans.

                      </li>
                      <li>
                         Content Accuracy <br>
                         While we strive to keep the information on this site up to date and accurate, we make no warranties or guarantees about the completeness, reliability, or suitability of the content.
                      </li>
                    </ol>
                  </p>
                </div>

                <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'About Us',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'about-us',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },

  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
